let inFlight = 0;
let started = 0;
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((listener) => listener());
}

/** Counts `request` as in flight until it settles, for `whenRequestsIdle`. */
export function trackRequest<T>(request: Promise<T>): Promise<T> {
  inFlight += 1;
  started += 1;
  notify();
  return request.finally(() => {
    inFlight -= 1;
    notify();
  });
}

/** Running count of tracked requests; diff two reads to count requests in a window. */
export function getRequestsStarted() {
  return started;
}

/**
 * Resolves once no tracked request has been in flight for `quietMs`, with the time activity last
 * stopped (the call time if already idle), or `null` after `timeoutMs`. Mirrors RUM loading time.
 */
export function whenRequestsIdle({ quietMs = 100, timeoutMs = 30_000 } = {}) {
  return new Promise<number | null>((resolve) => {
    let quietTimer: ReturnType<typeof setTimeout> | undefined;
    function finish(settledAt: number | null) {
      clearTimeout(quietTimer);
      clearTimeout(timeoutTimer);
      listeners.delete(check);
      resolve(settledAt);
    }
    function check() {
      clearTimeout(quietTimer);
      if (inFlight > 0) return;
      const idleSince = Date.now();
      quietTimer = setTimeout(() => finish(idleSince), quietMs);
    }
    const timeoutTimer = setTimeout(() => finish(null), timeoutMs);
    listeners.add(check);
    check();
  });
}
